import { slice } from './slice';

const { reducer } = slice;

export * from './thunks';
export * as ratesSelectors from './selectors';

export default reducer;
